export default {
    addNewError(state, error) {
        // console.log('error1: set new error');
        state.newError = error;
    },
};
